import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import { Paths } from '../../../shared/paths';

export default function FbAction() {
  const [searchParams] = useSearchParams();
  const { navigate } = useNavigationStack();

  useEffect(() => {
    const mode = searchParams.get('mode');

    switch (mode?.toLowerCase()) {
      case 'verifyemail': {
        const oobCode = searchParams.get('oobCode');
        navigate(Paths.toVerification(oobCode ?? undefined), { replace: true });
        break;
      }
      case 'resetpassword':
        navigate(`${Paths.resetPassword}?${searchParams.toString()}`);
        break;
      default:
        navigate('/');
    }
  }, []);

  return <div />;
}
